import React, { useState } from "react";
import { Button, Stack, Box } from "@mui/material";
import DoctorSpeciality from "./DoctorSpeciality";
import NewDoctorCountGraph from "./NewDoctorCountGraph";
import { useSalesContext } from "../../SalesContext";

const GraphCard: React.FC = () => {
  const [activeGraph, setActiveGraph] = useState<string>(
    "Number of Calls & Call Average"
  );
  const { secondaryKpiData, kpiData } = useSalesContext();
  const combinedData = kpiData?.barChart;
  const lineBarChartData = secondaryKpiData?.lineBarChart;

  const toggleGraph = (label: string) => {
    setActiveGraph(label);
  };

  return (
    <Box
      sx={{
        padding: 0,
        width: "100%",
        border: "2px solid #F5F5F5",
        marginTop: "10px",
      }}
    >
      <Stack direction="row" spacing={2} sx={{ marginBottom: 3 }}>
        {["Number of Calls & Call Average", "Doctor Speciality"].map(
          (label) => (
            <Button
              key={label}
              variant="text"
              onClick={() => toggleGraph(label)}
              sx={{
                textTransform: "none",
                borderRadius: "0px",
                borderBottom:
                  activeGraph === label ? "3px solid #00008B" : "none",
                backgroundColor: "transparent",
                color: "#000",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {label}
            </Button>
          )
        )}
      </Stack>
      <Box sx={{ height: "400px", width: "100%" }}>
        {activeGraph === "Number of Calls & Call Average" ? (
          <NewDoctorCountGraph lineBarChartData={lineBarChartData} />
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
            <DoctorSpeciality data={combinedData.limited} isLimited={true} />
            <DoctorSpeciality data={combinedData.full} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GraphCard;
